import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AutoComplete from "../../../../components/AutoComplete/AutoComplete";
import Datetime from "react-datetime";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import "../../../styles/forms.scss";

const DOCOnlineEducationForm = ({
  index,
  onDelete,
  education,
  onSelectedCourse,
  onSelectedSchool,
  onChangeStartDate,
  onChangeEndDate,
  docOnline,
  setDocOnline,
  errors,
  autoCompleteCourseData,
  autoCompleteSchoolData
}) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  let today = new Date();
  const [filledValues, setfilledValues] = useState(false);

  useEffect(() => {
    setfilledValues(hasValues());
  }, []);
  const onChangeCourse = (event, courseName, index) => {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    if (courseName.newValue === "") {
      _educationAndTraining[index]["courseId"] = undefined;
      _educationAndTraining[index]["courseName"] = undefined;
      if (_educationAndTraining[index]["course"]) {
        _educationAndTraining[index]["course"].description = undefined;
      }
    } else {
      _educationAndTraining[index]["courseId"] = undefined;
      _educationAndTraining[index]["courseName"] = courseName.newValue;
    }
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });

    setfilledValues(hasValues());
  };

  const onChangeOngoing = (index) => {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    if (_educationAndTraining[index]["isOngoing"] === true) {
      _educationAndTraining[index]["isOngoing"] = false;
    } else {
      _educationAndTraining[index]["isOngoing"] = true;
    }
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
  };

  const onChangeSchools = (event, schoolName, index) => {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    if (schoolName.newValue === "") {
      _educationAndTraining[index]["schoolId"] = undefined;
      _educationAndTraining[index]["schoolName"] = undefined;
      if (_educationAndTraining[index]["school"]) {
        _educationAndTraining[index]["school"].description = undefined;
      }
    } else {
      _educationAndTraining[index]["schoolId"] = undefined;
      _educationAndTraining[index]["schoolName"] = schoolName.newValue;
    }

    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
    setfilledValues(hasValues());
  };

  const getDateValueValid = (date) => {
    if (date) return new Date(date);
  };

  const isValidEndDate = (currentDate) => {
    if (education.startDate) return new Date(education.startDate) < currentDate;
    else return true;
  };

  const isValidStartDate = (currentDate) => {
    if (education.endDate) return new Date(education.endDate) > currentDate;
    else return true;
  };

  const onChangeIsCertification = (index) => {
    let _educationAndTraining = [...docOnline.educationAndTraining];
    if (_educationAndTraining[index]["isCertification"] === true) {
      _educationAndTraining[index]["isCertification"] = false;
    } else {
      _educationAndTraining[index]["isCertification"] = true;
    }
    setDocOnline({
      ...docOnline,
      educationAndTraining: _educationAndTraining
    });
  };
  const hasValues = () => {
    for (let keys in education) {
      if (education[keys]) return true;
    }
  };

  function changeStartingDate(date, index) {
    onChangeStartDate(date, index);
    setfilledValues(hasValues());
  }

  function changeEndDate(date, index) {
    onChangeEndDate(date, index);
    setfilledValues(hasValues());
  }
  return (
    <div>
      {index === 0 ? (
        <div className="education-form" style={{ width: "92%" }}>
          <div className="form-group course">
            <div className="label-wrapper">
              <label>
                {t("Course")}
                {filledValues && <label className="star-style">*</label>}
              </label>
              {education.id == 0 && (
                <span className="star-style">{t("Unsaved")}</span>
              )}

              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].course && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].course}
                  </span>
                )}
            </div>
            <AutoComplete
              data={autoCompleteCourseData}
              onChange={(event, courseName) => {
                onChangeCourse(event, courseName, index);
              }}
              onSelection={(courseId) => onSelectedCourse(courseId, index)}
              value={
                education.courseName ||
                (education.course && education.course.description) ||
                ""
              }
              placeholder={t("Title of qualification awarded")}
            />
          </div>
          <div
            className="form-group is-certificate"
            style={{ marginTop: "15px" }}
          >
            <div className="label-wrapper">
              <label>{t("Is Certification")}?</label>
            </div>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="isCertification"
                name="isCertification"
                checked={education.isCertification}
                onChange={() => onChangeIsCertification(index)}
                style={{ marginLeft: "10px" }}
              />
            </div>
          </div>
          <div className="form-group institution">
            <div className="label-wrapper">
              <label>
                {t("Institution")}
                {filledValues && <label className="star-style">*</label>}
              </label>
              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].schoolName && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].schoolName}
                  </span>
                )}
            </div>
            <AutoComplete
              data={autoCompleteSchoolData}
              onChange={(event, name) => {
                onChangeSchools(event, name, index);
              }}
              onSelection={(schoolId) => onSelectedSchool(schoolId, index)}
              value={
                education.schoolName ||
                (education.school && education.school.description) ||
                ""
              }
              placeholder={t("Organization providing education and training")}
            />
          </div>
          <div className="form-group start-date">
            <div className="label-wrapper">
              <label htmlFor="startDate">
                {t("Start date")}
                {filledValues && <label className="star-style">*</label>}
              </label>
              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].startDate && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].startDate}
                  </span>
                )}
            </div>
            <Datetime
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ placeholder: t("dd-mm-yyyy") }}
              onChange={(date) => changeStartingDate(date, index)}
              utc={true}
              id="startDate"
              name="startDate"
              value={getDateValueValid(education.startDate)}
              isValidDate={isValidStartDate}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
            />
          </div>
          <div className="form-group end-date">
            <div className="label-wrapper">
              <label htmlFor="endDate">{t("End Date")}</label>
              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].endDate && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].endDate}
                  </span>
                )}
            </div>
            <Datetime
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ placeholder: t("dd-mm-yyyy") }}
              onChange={(date) => changeEndDate(date, index)}
              utc={true}
              id="endDate"
              name="endDate"
              value={getDateValueValid(education.endDate)}
              isValidDate={isValidEndDate}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
            />
          </div>
          <div className="ongoing" style={{ marginTop: "15px" }}>
            <div className="label-wrapper">
              <label htmlFor="onGoing">{t("Ongoing")}?</label>
            </div>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="isOngoing"
                name="isOngoing"
                checked={education.isOngoing}
                onChange={() => onChangeOngoing(index)}
                style={{ marginLeft: "10px" }}
                disabled={
                  getDateValueValid(education.endDate) < today ? true : false
                }
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="education-form separator">
          <div className="form-group course">
            <div className="row">
              <div className="col">
                <div className="label-wrapper">
                  <label>
                    {t("Course")}
                    {hasValues() && <label className="star-style">*</label>}
                  </label>{" "}
                  {errors.educationAndTraining !== undefined &&
                    errors.educationAndTraining[index] !== undefined &&
                    errors.educationAndTraining[index].course && (
                      <span className="error-msg">
                        {errors.educationAndTraining[index].course}
                      </span>
                    )}
                </div>
              </div>
              <div className="col text-end">
                {education.id == 0 && (
                  <span class="border border-danger text-danger fs-6   rounded">
                    {t("unsaved")}
                  </span>
                )}
              </div>
            </div>
            <AutoComplete
              data={autoCompleteCourseData}
              onChange={(event, courseName) => {
                onChangeCourse(event, courseName, index);
              }}
              onSelection={(courseId) => onSelectedCourse(courseId, index)}
              value={
                education.courseName ||
                (education.course && education.course.description) ||
                ""
              }
              placeholder={t("Title of qualification awarded")}
            />
          </div>
          <div
            className="form-group is-certificate"
            style={{ marginTop: "15px" }}
          >
            <div className="label-wrapper">
              <label>{t("Is Certification")}?</label>
            </div>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="isCertification"
                name="isCertification"
                checked={education.isCertification}
                onChange={() => onChangeIsCertification(index)}
                style={{ marginLeft: "10px" }}
              />
            </div>
          </div>
          <div className="form-group institution">
            <div className="label-wrapper">
              <label>
                {t("Institution")}
                {hasValues() && <label className="star-style">*</label>}
              </label>
              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].schoolName && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].schoolName}
                  </span>
                )}
            </div>
            <AutoComplete
              data={autoCompleteSchoolData}
              onChange={(event, name) => {
                onChangeSchools(event, name, index);
              }}
              onSelection={(schoolId) => onSelectedSchool(schoolId, index)}
              value={
                education.schoolName ||
                (education.school && education.school.description) ||
                ""
              }
              placeholder={t("Organization providing education and training")}
            />
          </div>
          <div className="form-group start-date">
            <div className="label-wrapper">
              <label htmlFor="startDate">
                {t("Start date")}
                {hasValues() && <label className="star-style">*</label>}
              </label>
              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].startDate && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].startDate}
                  </span>
                )}
            </div>
            <Datetime
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ placeholder: t("dd-mm-yyyy") }}
              onChange={(date) => onChangeStartDate(date, index)}
              utc={true}
              id="startDate"
              name="startDate"
              value={getDateValueValid(education.startDate)}
              isValidDate={isValidStartDate}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
            />
          </div>
          <div className="form-group end-date">
            <div className="label-wrapper">
              <label htmlFor="endDate">{t("End Date")}</label>
              {errors.educationAndTraining !== undefined &&
                errors.educationAndTraining[index] !== undefined &&
                errors.educationAndTraining[index].endDate && (
                  <span className="error-msg">
                    {errors.educationAndTraining[index].endDate}
                  </span>
                )}
            </div>
            <Datetime
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{ placeholder: t("dd-mm-yyyy") }}
              onChange={(date) => onChangeEndDate(date, index)}
              utc={true}
              id="endDate"
              name="endDate"
              value={getDateValueValid(education.endDate)}
              isValidDate={isValidEndDate}
              locale={
                i18n.language === "PT"
                  ? "PT"
                  : i18n.language === "FR"
                  ? "FR"
                  : "EN"
              }
            />
          </div>
          <div className="ongoing" style={{ marginTop: "15px" }}>
            <div className="label-wrapper">
              <label htmlFor="onGoing">{t("Ongoing")}?</label>
            </div>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="isOngoing"
                name="isOngoing"
                checked={education.isOngoing}
                onChange={() => onChangeOngoing(index)}
                style={{ marginLeft: "10px" }}
                disabled={
                  getDateValueValid(education.endDate) < today ? true : false
                }
              />
            </div>
            <div className="delete-button" style={{ marginTop: "5px" }}>
              <button
                type="button"
                id="deleteEducationExperience"
                onClick={() => onDelete(index)}
                className="app-button btn-second btn-md"
              >
                {t("Delete")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DOCOnlineEducationForm;
